import { lightTheme } from 'hfs-common-ui';
import type { DefaultTheme } from 'styled-components';

export const defaultState: AppStateFields = {
  isInitializingApp: true,
  analyticsReported: false,
  timestamp: undefined,
  theme: lightTheme,
  isLightTheme: true,
  showOldVersionWarning: false,
};

export interface AppStateFields {
  isInitializingApp: boolean;
  analyticsReported: boolean;
  isLightTheme: boolean;
  theme: DefaultTheme;
  timestamp?: string;
  showOldVersionWarning: boolean;
  wsReconnectionDate?: Date;
}
